import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import Select from "react-select";
import { _serverUrl2 } from "../../../config";
import { loading, removeLoading } from "../../../Utils/Alerts2";
import { addFeatureFromGeojson, addPolygonsWithColor, tempLayer } from "../../../Utils/MapUtils";
import { MyMap } from "../../Map/View/MyMap";
import ProjectSideBar from "./ProjectSideBar";

export default function ProjectDetay() {
  const history = useHistory();

  const [step, setStep] = useState(0);

  const [selectedTasks, setSelectedTasks] = useState([]);

  const [users, setUsers] = useState([]);
  const [areas, setAreas] = useState([]);

  const projeID = useParams().id;
  const [bolgeId, setBolgeId] = useState(0);
  const [proje, setProje] = useState({});
  const [userList, setUserList] = useState([]);
  const [searchValue, setSearchValue] = useState(""); // Arama değerini saklayan state
  const [selectedUser, setSelectedUser] = useState([]); // seçtiğim kişileri saklayan state

  const getInfos = useCallback(async () => {
    loading();
    await axios
      .get(_serverUrl2 + "/projects/get/" + projeID)
      .then((res) => {
        console.log(res, "reseweeff");
        if (res.data.status) {
          setProje(res.data.rows[0]);
        } else {
        }
      })
      .catch(() => {});

    await axios.get(_serverUrl2 + "/projects/getAreas/" + projeID).then((res) => {
      setAreas(res.data.rows);
      tempLayer.getSource().clear();
      res.data.rows.map((d) => {
        return addPolygonsWithColor(d.geojson, d.color, d.bolge_adi, d.id);
      });
    });

    await axios
      .get(_serverUrl2 + "/user/getLevhaUsers")
      .then((res) => {
        if (res.data.status) {
          console.log(
            res.data.rows.map((r) => {
              return {
                value: r.id,
                label: r.kullanici_adi,
                selected: false,
              };
            })
          );
          setUsers(
            res.data.rows.map((r) => {
              return {
                value: r.id,
                label: r.kullanici_adi,
                selected: false,
              };
            })
          );
        } else {
        }
      })
      .catch(() => {})
      .finally(() => {
        removeLoading();
      });
  }, [projeID]);

  const onChangeArea = async (id) => {
    if (id == undefined) {
      const updatedUsers = users.map((user) => {
        return {
          ...user,
          selected: false,
        };
      });

      setUsers(updatedUsers);
      return;
    }

    loading();
    tempLayer.getSource().clear();
    let selectedItem = areas.find((D) => D.id == id);

    setBolgeId(id);
    kisiGorev(id);
    addPolygonsWithColor(selectedItem.geojson, selectedItem.color);
    await axios
      .post(_serverUrl2 + "/projects/getIncludes", {
        proje_id: projeID,
        geom: selectedItem.geom,
      })
      .then((res) => {
        console.log(res.data.rows, "onchangeArea");
        setSelectedTasks(res.data.rows);
        res.data.rows.map((d) => {
          return addFeatureFromGeojson(d.geo);
        });
        setStep(2);
      })
      .finally(() => {
        removeLoading();
      });
  };

  const gorevAta = async () => {
    let body = new FormData();
    body.append(
      "body",
      JSON.stringify({
        gorevler: selectedTasks,
        userId: selectedUser,
        bolgeId: bolgeId,
      })
    );
    await axios.post(_serverUrl2 + "/projects/gorevAta", body).then((res) => {
      console.log(res, "görevAta");
      alert("İşlem Başarılı! Görevler Atandı");
      setStep(0);
      setSelectedTasks([]);
      setSelectedUser([]);
    });
  };

  const getUserList = async () => {
    await axios
      .get(_serverUrl2 + "/projects/getUserList")
      .then((res) => {
        console.log(res.data.rows, "getUserList");
        setUserList(res.data.rows);
      })
      .catch(() => {});
  };
  const handleSearchChange = (value) => {
    setSearchValue(value);
  };

  const getFilteredOptions = () => {
    return areas
      .filter((area) => area.bolge_adi.toLowerCase().includes(searchValue.toLowerCase()))
      .map((area) => ({
        value: area.id,
        label: area.bolge_adi,
      }));
  };
  const handleUserSelect = (e) => {
    setSelectedUser(e);
    console.log(e, "handleUserSelectt");

    const selectedUserIds = e.map((option) => option.value);

    // `users` dizisini güncelle
    const updatedUsers = users.map((user) => {
      return {
        ...user,
        selected: selectedUserIds.includes(user.value),
      };
    });

    setUsers(updatedUsers);

    setStep(3);
  };

  const kisiGorev = async (bolgeId) => {
    await axios.get(_serverUrl2 + "/projects/getGorevlendirilen/" + bolgeId).then((res) => {
      const x = res.data.rows[0].gorevlendirilen_kisiler;
      console.log("gggg", x);
      let c = [];
      if (x != null) {
        c = x.replace("{", "").replace("}", "").split(",");
        c = c.map((a) => {
          return parseInt(a);
        });
      }
      console.log("ccccccc", c);
      let arr = [...users];
      for (let i = 0; i < arr.length; i++) {
        if (c.includes(arr[i].value)) {
          arr[i].selected = true;
        } else {
          arr[i].selected = false;
        }
      }
      setUsers(arr);
      console.log(c, "kisiGorev");
      const mappedC = c.map((userId) => ({ value: userId, label: "Kullanıcı Adları" }));
      handleUserSelect(mappedC);
    });
  };

  useEffect(() => {
    getUserList();
    tempLayer.getSource().clear();
    MyMap.addLayer(tempLayer);
    getInfos();
    return () => {
      MyMap.removeLayer(tempLayer);
      tempLayer.getSource().clear();
    };
  }, [getInfos]);

  return (
    <div className="row" style={{ fontSize: "12px" }}>
      <div className="col-12">
        <ProjectSideBar page={"3"} />
      </div>
      <div className="col-sm-12">
        <div>
          <div className="content d-flex justify-content-between">
            <button className="orangeBtn" style={{ fontSize: "13px", width: "30px" }} onClick={() => history.goBack()}>
              <i className="fas fa-arrow-left"></i>
            </button>
            <b>{proje.proje_adi}</b>
            <b>&nbsp;</b>
          </div>
        </div>
      </div>

      {step >= 0 && (
        <>
          <div className="row" style={{ marginTop: "15px" }}>
            <div className="col-sm-12" style={{ display: "flex", justifyContent: "space-between" }}>
              <div className="col-sm-2">
                <center style={{ padding: "1px", paddingTop: "2px", backgroundColor: "#5f94ae", color: "white ", borderRadius: 50, width: "30px" }}>
                  <h5>1</h5>
                </center>
              </div>
              <Select
                className="form-control"
                options={getFilteredOptions()}
                onChange={(selectedOption) => onChangeArea(selectedOption?.value)}
                onInputChange={handleSearchChange}
                isClearable
                placeholder="Seçiniz"
              />
              {/*</div><div className='col-sm-10 d-flex' style={{ justifyContent: 'center' }}>
                                Bölge Seçimi
            */}
              {/*
                            <select className='form-control form-select' onChange={(e) => onChangeArea(e.target.value)} >
                                    <option disabled selected >Seçiniz</option>
                                    {areas.map((d, i) => {
                                        return <option value={d.id}>{d.bolge_adi}</option>
                                    })}
                                </select> 
                            </div>
                            */}
            </div>
          </div>
          <hr style={{ marginTop: "5px" }}></hr>
        </>
      )}
      {step >= 1 && (
        <>
          <div className="row">
            <div className="col-sm-12" style={{ display: "flex", justifyContent: "space-between" }}>
              <div className="col-sm-2">
                <center style={{ padding: "1px", paddingTop: "2px", backgroundColor: "#5f94ae", color: "white ", borderRadius: 50, width: "30px" }}>
                  <h5>2</h5>
                </center>
              </div>
              <div className="col-sm-10 d-flex" style={{ justifyContent: "center" }}>
                Toplam ({selectedTasks.length}) Görev Seçildi!
              </div>
            </div>
          </div>
          <hr style={{ marginTop: "5px" }}></hr>
        </>
      )}
      {step >= 2 && (
        <>
          <div className="row">
            <div className="col-sm-12" style={{ display: "flex", justifyContent: "space-between" }}>
              <div className="col-sm-2">
                <center style={{ padding: "1px", paddingTop: "2px", backgroundColor: "#5f94ae", color: "white ", borderRadius: 50, width: "30px" }}>
                  <h5>3</h5>
                </center>
              </div>
              <div className="col-sm-10 d-flex" style={{ justifyContent: "center" }}>
                <label>Görevin Atanacağı Kişiyi Seçiniz.</label>
              </div>
            </div>
            <div className="col-2"></div>
            <div className="col-10">
              {/* <Select
                                className="basic-multi-select"
                                value={null}
                                options={users.map((d) => ({
                                    value: d.id,
                                    label: d.kullanici_adi,
                                }))}
                              
                                isMulti
                            />*/}
              <Select
                onChange={handleUserSelect}
                isMulti
                name="colors"
                value={users.filter((u) => u.selected)}
                options={users}
                className="basic-multi-select"
                classNamePrefix="select"
              />
            </div>
            {/*<div className='col-sm-10 d-flex' style={{ justifyContent: 'center' }}>
                            <select className='form-control form-control-sm' id='userr' onChange={() => setStep(3)} >
                                <option disabled selected >Seçiniz..</option>
                                {users.map((d, i) => {
                                    return <option value={d.id} >{d.kullanici_adi}</option>
                                })}
                            </select>
                        </div> */}
          </div>
          <hr style={{ marginTop: "10px" }}></hr>
        </>
      )}
      {step >= 3 && (
        <>
          <div className="row">
            <div className="col-sm-12" style={{ display: "flex", justifyContent: "space-between" }}>
              <div className="col-sm-2">
                <center style={{ padding: "1px", paddingTop: "2px", backgroundColor: "#5f94ae", color: "white ", borderRadius: 50, width: "30px" }}>
                  <h5>4</h5>
                </center>
              </div>
              <div className="col-sm-10 d-flex" style={{ justifyContent: "center" }}>
                <button className="btn btn-success btn-sm form-control" onClick={() => gorevAta()}>
                  Seçilen Kişiye Görev Olarak Ata
                </button>
              </div>
            </div>
          </div>
        </>
      )}
      <div className="row">
        <div className="col-12">
          <table className="table">
            <thead>
              <tr style={{ backgroundColor: "#335c67", color: "white" }}>
                <th>Kullanıcı Adı</th>
                <th>Toplam Atanmış Görev Sayısı</th>
                <th> Atanmış Bölgeler</th>
              </tr>
            </thead>
            <tbody>
              {userList.map((d, i) => (
                <tr key={i}>
                  <td>{d.kullanici_adi}</td>
                  <td>{d.val}</td>
                  <td>{d.bolgeler}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

/*
select * from yanbis.nl_gorevler
;
 
 
  insert into yanbis.nl_gorevler (tip,maks_kn,geom,proje_id,sablon_id,gorev_durum)
  select 'YAPI',brk.maks_yapi_kn,brk.geom,1,0,'ATANMADI' from yanbis.bina_risk_degerleme brk
*/
